import ArticlesBlockEmbed from './articles-block-embed'
import ArticlesBlockEmbedQuery from './articles-block-embed.query'

export { ArticlesBlockEmbedQuery }

export default ArticlesBlockEmbed
